import data from '../data/data';
import countries from '../data/countries';
import currencies_supported from '../data/currencies_supported';
import rates from '../data/currencies_rates';

export default {
  autoplay: {
    autoplay: true
  },
  data: data,
  countries: countries,
  currencies: {
    rates: rates,
    supported: currencies_supported
  },
  userLocation: {
    isFetching: false,
    country_code_2: null,
    default_city_has_been_set: false,
    from_city_id: null,
    from_city_name: null,
    customized: false,
    currency_code: 'USD'
  },
  prices: {
    isFetching: false,
    prices: null
  },
  selection: {
    promoDisplayed: true,
    currentMonth: 1,
    infobox_area_id: false,
    displayed: false,
    area_ids: []
  },
  options: {
    display_recommended: true,
    display_temperatures: false,
    display_precipitations: false
  }
};



/** WEBPACK FOOTER **
 ** ./src/reducers/initialState.js
 **/